var scope_0 = require('/home/runner/work/pc123-gatsby/pc123-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6ed6377249bee030bee2069d29e22671.js').default;
var scope_1 = require('/home/runner/work/pc123-gatsby/pc123-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/home/runner/work/pc123-gatsby/pc123-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee636e0c40ec06fe194ae35495b1ce83.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    